/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { SourcingSearchAvailabilityFrequency } from './';
import {
    SourcingSearchAvailabilityFrequencyFromJSON,
    SourcingSearchAvailabilityFrequencyFromJSONTyped,
    SourcingSearchAvailabilityFrequencyToJSON,
} from './';
import type { SourcingSearchCodeWithLabel } from './';
import {
    SourcingSearchCodeWithLabelFromJSON,
    SourcingSearchCodeWithLabelFromJSONTyped,
    SourcingSearchCodeWithLabelToJSON,
} from './';
import type { SourcingSearchExperienceLevel } from './';
import {
    SourcingSearchExperienceLevelFromJSON,
    SourcingSearchExperienceLevelFromJSONTyped,
    SourcingSearchExperienceLevelToJSON,
} from './';
import type { SourcingSearchFilterDailyRate } from './';
import {
    SourcingSearchFilterDailyRateFromJSON,
    SourcingSearchFilterDailyRateFromJSONTyped,
    SourcingSearchFilterDailyRateToJSON,
} from './';
import type { SourcingSearchFilterLocation } from './';
import {
    SourcingSearchFilterLocationFromJSON,
    SourcingSearchFilterLocationFromJSONTyped,
    SourcingSearchFilterLocationToJSON,
} from './';
import type { SourcingSearchFreelancerVertical } from './';
import {
    SourcingSearchFreelancerVerticalFromJSON,
    SourcingSearchFreelancerVerticalFromJSONTyped,
    SourcingSearchFreelancerVerticalToJSON,
} from './';

/**
 * 
 * @export
 * @interface SourcingSearchFilters
 */
export interface SourcingSearchFilters {
    /**
     * 
     * @type {SourcingSearchFreelancerVertical}
     * @memberof SourcingSearchFilters
     */
    vertical: SourcingSearchFreelancerVertical;
    /**
     * 
     * @type {string}
     * @memberof SourcingSearchFilters
     */
    query: string;
    /**
     * 
     * @type {Array<SourcingSearchCodeWithLabel>}
     * @memberof SourcingSearchFilters
     */
    languages: Array<SourcingSearchCodeWithLabel>;
    /**
     * 
     * @type {SourcingSearchAvailabilityFrequency}
     * @memberof SourcingSearchFilters
     */
    availabilityFrequency?: SourcingSearchAvailabilityFrequency;
    /**
     * 
     * @type {SourcingSearchExperienceLevel}
     * @memberof SourcingSearchFilters
     */
    experienceLevel?: SourcingSearchExperienceLevel;
    /**
     * 
     * @type {SourcingSearchFilterDailyRate}
     * @memberof SourcingSearchFilters
     */
    dailyRate: SourcingSearchFilterDailyRate;
    /**
     * 
     * @type {SourcingSearchFilterLocation}
     * @memberof SourcingSearchFilters
     */
    location?: SourcingSearchFilterLocation;
    /**
     * 
     * @type {string}
     * @memberof SourcingSearchFilters
     */
    locationLabel?: string;
    /**
     * 
     * @type {Array<SourcingSearchCodeWithLabel>}
     * @memberof SourcingSearchFilters
     */
    countries: Array<SourcingSearchCodeWithLabel>;
    /**
     * 
     * @type {Array<SourcingSearchCodeWithLabel>}
     * @memberof SourcingSearchFilters
     */
    functionalSkills: Array<SourcingSearchCodeWithLabel>;
    /**
     * 
     * @type {Array<SourcingSearchCodeWithLabel>}
     * @memberof SourcingSearchFilters
     */
    industryExpertises: Array<SourcingSearchCodeWithLabel>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SourcingSearchFilters
     */
    skills: Array<string>;
}

/**
 * Check if a given object implements the SourcingSearchFilters interface.
 */
export function instanceOfSourcingSearchFilters(value: object): value is SourcingSearchFilters {
    if (!('vertical' in value) || value['vertical'] === undefined) return false;
    if (!('query' in value) || value['query'] === undefined) return false;
    if (!('languages' in value) || value['languages'] === undefined) return false;
    if (!('dailyRate' in value) || value['dailyRate'] === undefined) return false;
    if (!('countries' in value) || value['countries'] === undefined) return false;
    if (!('functionalSkills' in value) || value['functionalSkills'] === undefined) return false;
    if (!('industryExpertises' in value) || value['industryExpertises'] === undefined) return false;
    if (!('skills' in value) || value['skills'] === undefined) return false;
    return true;
}

export function SourcingSearchFiltersFromJSON(json: any): SourcingSearchFilters {
    return SourcingSearchFiltersFromJSONTyped(json, false);
}

export function SourcingSearchFiltersFromJSONTyped(json: any, ignoreDiscriminator: boolean): SourcingSearchFilters {
    if (json == null) {
        return json;
    }
    return {
        
        'vertical': SourcingSearchFreelancerVerticalFromJSON(json['vertical']),
        'query': json['query'],
        'languages': ((json['languages'] as Array<any>).map(SourcingSearchCodeWithLabelFromJSON)),
        'availabilityFrequency': json['availabilityFrequency'] == null ? undefined : SourcingSearchAvailabilityFrequencyFromJSON(json['availabilityFrequency']),
        'experienceLevel': json['experienceLevel'] == null ? undefined : SourcingSearchExperienceLevelFromJSON(json['experienceLevel']),
        'dailyRate': SourcingSearchFilterDailyRateFromJSON(json['dailyRate']),
        'location': json['location'] == null ? undefined : SourcingSearchFilterLocationFromJSON(json['location']),
        'locationLabel': json['locationLabel'] == null ? undefined : json['locationLabel'],
        'countries': ((json['countries'] as Array<any>).map(SourcingSearchCodeWithLabelFromJSON)),
        'functionalSkills': ((json['functionalSkills'] as Array<any>).map(SourcingSearchCodeWithLabelFromJSON)),
        'industryExpertises': ((json['industryExpertises'] as Array<any>).map(SourcingSearchCodeWithLabelFromJSON)),
        'skills': json['skills'],
    };
}

export function SourcingSearchFiltersToJSON(value?: SourcingSearchFilters | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'vertical': SourcingSearchFreelancerVerticalToJSON(value['vertical']),
        'query': value['query'],
        'languages': ((value['languages'] as Array<any>).map((v) => SourcingSearchCodeWithLabelToJSON(v))),
        'availabilityFrequency': SourcingSearchAvailabilityFrequencyToJSON(value['availabilityFrequency']),
        'experienceLevel': SourcingSearchExperienceLevelToJSON(value['experienceLevel']),
        'dailyRate': SourcingSearchFilterDailyRateToJSON(value['dailyRate']),
        'location': SourcingSearchFilterLocationToJSON(value['location']),
        'locationLabel': value['locationLabel'],
        'countries': ((value['countries'] as Array<any>).map((v) => SourcingSearchCodeWithLabelToJSON(v))),
        'functionalSkills': ((value['functionalSkills'] as Array<any>).map((v) => SourcingSearchCodeWithLabelToJSON(v))),
        'industryExpertises': ((value['industryExpertises'] as Array<any>).map((v) => SourcingSearchCodeWithLabelToJSON(v))),
        'skills': value['skills'],
    };
}

